import React from 'react';
import { Card, Icon, Text } from '../../../common/components';

interface TimelineEmptyStateProps {
  title: string;
  text: string;
}

/** Prázdný stav historie kontrol — sdílený mezi modulem Rejstříky a detailem jednotky. */
const TimelineEmptyState: React.FC<TimelineEmptyStateProps> = ({ title, text }) => (
  <Card className="TimelineEmpty">
    <Icon name="shield" color="Primary500" />
    <Text size="h3" color="Neutral800">
      {title}
    </Text>
    <Text size="body-medium" color="Neutral600">
      {text}
    </Text>
  </Card>
);

export default TimelineEmptyState;
